/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".chart-main-container[_ngcontent-%COMP%]   .chart-container[_ngcontent-%COMP%]{max-height:450px;width:100%}"];
export { styles as styles };
